<template>
  <div class="exclusive-recipe">
    <div class="header">
      <div class="custom-campus-select" @click="showCampusSheet = true">
        <span class="campus-name">{{ selectedCampus }}</span>
        <van-icon name="arrow-down" class="campus-arrow" />
      </div>
      <van-action-sheet
        v-model:show="showCampusSheet"
        :actions="campusOptions"
        @select="onSelectCampus"
        cancel-text="取消"
      />
      <div class="date-select">
        <van-icon
          name="arrow-left"
          class="date-arrow"
          :class="{ disabled: selectedDateIdx === 0 }"
          @click="prevDate"
        />
        <div class="date-scroll">
          <div class="week-row">
            <div
              v-for="(date, idx) in weekDates"
              :key="'week-' + idx"
              class="week-label"
            >
              {{ date.weekLabel }}
            </div>
          </div>
          <div class="date-row">
            <div
              v-for="(date, idx) in weekDates"
              :key="date.day + date.label"
              :class="['date-item', { active: idx === selectedDateIdx }]"
              @click="
                selectedDateIdx = idx;
                getStandardMealDishList();
              "
              :ref="(el) => setDateItemRef(idx, el)"
            >
              <div class="date-day">{{ date.day }}</div>
              <div class="date-label">{{ date.label }}</div>
            </div>
          </div>
        </div>
        <van-icon
          name="arrow"
          class="date-arrow right"
          :class="{ disabled: selectedDateIdx === weekDates.length - 1 }"
          @click="nextDate"
        />
      </div>
    </div>
    <div class="tab-wrpa">
      <div class="tab-list">
        <div
          :class="[mealType === item.value ? 'active-tab' : 'tab-name']"
          v-for="item in mealTabs"
          :key="item.value"
          @click="
            mealType = item.value;
            getStandardMealDishList();
          "
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <div
      class="meal-section"
      v-for="(item, index) in chineseMeals"
      :key="index"
    >
      <div class="section-title">
        {{ item.mealName }}

        <span style="font-size: 12px; margin-left: 8px">{{
          item.describe
        }}</span>
      </div>
      <div class="meal-list" v-if="item.dishList && item.dishList.length > 0">
        <div class="meal-item" v-for="(h, idx) in item.dishList" :key="idx">
          <img
            :src="getImg(h.img)"
            class="meal-img"
            @click="handleGoDetail(h)"
          />
          <div class="meal-name">{{ h.name }}</div>
        </div>
      </div>
      <div v-else class="empty-placeholder">
        <van-empty description="暂无菜品" image-size="60" />
      </div>
    </div>
    <div v-if="!chineseMeals.length" class="meal-section">
      <van-empty description="暂无套餐" image-size="60" />
    </div>
    <div class="bottom-button" v-if="isShowBtn">
      <van-button type="primary" @click="handleReserve" class="reserve-btn"
        >立即预约</van-button
      >
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick, watch, onMounted, reactive, computed } from "vue";
import { showToast } from "vant";
import { querySyOrgSelectList, queryStandardMealDishList } from "@/api/meal";
import dayjs from "dayjs";
import { useRouter, useRoute } from "vue-router";
import { postSyparamSelectList } from "@/api/report";

const campusOptions = ref([]);
const selectedCampus = ref(null);
const selectedCampusValue = ref(null);
const showCampusSheet = ref(false);

const route = useRoute();
const router = useRouter();

const state = reactive({
  userId: null,
  realName: null,
  phone: null,
  limitTime: '11:00',
  lunchTPlus: 0,
  lunchBigDesc: '09:00',
  dinnerTPlus: 0,
  dinnerBigDesc: '15:00',
  configUpdateTime: 0 // 用于触发响应式更新
});

const onSelectCampus = (item) => {
  selectedCampus.value = item.name;
  selectedCampusValue.value = item.id;
  showCampusSheet.value = false;
  // 重置选中日期，确保按钮逻辑基于新校区的T+配置重新计算
  selectedDateIdx.value = 0;
  if (isCustomer.value == 1) {
    gettimeLimit();
  }
  getStandardMealDishList();
};

function getWeekDates(startFromToday = false) {
  const result = [];
  const weekLabels = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  const today = dayjs();
  const start = startFromToday ? today.startOf('day') : today.add(1, 'day').startOf('day');
  const dayOfWeek = start.day();
  const daysToNextSunday = ((7 - dayOfWeek) % 7) + 7;
  const end = start.add(daysToNextSunday, 'day').startOf('day');

  let currentDate = start.clone();
  while (currentDate.isSameOrBefore(end, 'day')) {
    const day = currentDate.date().toString().padStart(2, "0");
    const label = `${currentDate.month() + 1}月`;
    const fullDate = currentDate.format('YYYY-MM-DD');
    const weekLabel = weekLabels[currentDate.day()];
    result.push({ day, label, d: fullDate, weekLabel });
    currentDate = currentDate.add(1, 'day');
  }
  return result;
}

const weekDates = ref([]);
const selectedDateIdx = ref(0);
const mealType = ref(2);

const isCustomer = ref(0);

// 根据 isCustomer 初始化 weekDates
const initWeekDates = () => {
  const customerMode = isCustomer.value == 1;
  weekDates.value = getWeekDates(customerMode);
  selectedDateIdx.value = 0;
  // 读取缓存日期并设置默认选中
  if (isCustomer.value != 1) {
    const cachedDate = localStorage.getItem('exclusiveRecipeSelectedDate');
    if (cachedDate) {
      const idx = weekDates.value.findIndex(date => date.d === cachedDate);
      if (idx !== -1) {
        selectedDateIdx.value = idx;
      }
    }
  }
  
};

const dateItemRefs = ref([]);
function setDateItemRef(idx, el) {
  dateItemRefs.value[idx] = el;
}

watch(selectedDateIdx, (idx) => {
  nextTick(() => {
    const el = dateItemRefs.value[idx];
    if (el && el.scrollIntoView) {
      el.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  });
});

const isShowBtn = computed(() => {
  const currentDate = weekDates.value?.[selectedDateIdx.value];
  const plannedDiningTime = currentDate?.d;
  // 引用 configUpdateTime 确保响应式更新
  const configTs = state.configUpdateTime;
  console.log("isShowBtn:", {
    isCustomer: isCustomer.value,
    mealType: mealType.value,
    plannedDiningTime,
    lunchTPlus: state.lunchTPlus,
    lunchBigDesc: state.lunchBigDesc,
    dinnerTPlus: state.dinnerTPlus,
    dinnerBigDesc: state.dinnerBigDesc,
    configTs
  });

  if (!plannedDiningTime) return false;

  if (isCustomer.value == 1) {
    if (mealType.value === 2 && !state.lunchBigDesc) return false;
    if (mealType.value === 3 && !state.dinnerBigDesc) return false;
  } else {
    if (!state.limitTime) return false;
  }

  return canOperateReservation(plannedDiningTime) && chineseMeals.value.length;
});

// 判断是否允许操作预约
const canOperateReservation = (plannedDiningTime) => {
  const now = dayjs();
  const today = now.startOf("day");
  const plannedDate = dayjs(plannedDiningTime).startOf("day");
  const diffDays = plannedDate.diff(today, "day");

  // 客户模式：code=2 午餐，code=3 晚餐，value 表示 T+value
  if (isCustomer.value == 1) {
    if (mealType.value === 2) {
      // 午餐：limitDate = 今天 + lunchTPlus 天
      const tPlus = state.lunchTPlus;
      const [hour, minute] = state.lunchBigDesc.split(":").map(Number);
      const limitDate = today.add(tPlus, "day");
      // limitTime = 今天 + 截止时间（判断今天是否超过这个时间）
      const limitTime = today.add(hour, "hour").add(minute, "minute");

      console.log("午餐判断:", {
        今天: today.format("YYYY-MM-DD"),
        选择日期: plannedDate.format("YYYY-MM-DD"),
        diffDays,
        tPlus,
        limitDate: limitDate.format("YYYY-MM-DD"),
        limitTime: limitTime.format("YYYY-MM-DD HH:mm"),
        now: now.format("YYYY-MM-DD HH:mm"),
        isBeforeLimit: now.isBefore(limitTime)
      });

      if (diffDays < tPlus) {
        return false; // 日期太早
      }
      if (diffDays === tPlus) {
        // 正好是目标日期，判断今天是否超过截止时间
        return now.isBefore(limitTime);
      }
      return true; // 日期超过目标日期，可以操作
    } else if (mealType.value === 3) {
      // 晚餐：limitDate = 今天 + dinnerTPlus 天
      const tPlus = state.dinnerTPlus;
      const [hour, minute] = state.dinnerBigDesc.split(":").map(Number);
      const limitDate = today.add(tPlus, "day");
      // limitTime = 今天 + 截止时间（判断今天是否超过这个时间）
      const limitTime = today.add(hour, "hour").add(minute, "minute");

      console.log("晚餐判断:", {
        今天: today.format("YYYY-MM-DD"),
        选择日期: plannedDate.format("YYYY-MM-DD"),
        diffDays,
        tPlus,
        limitDate: limitDate.format("YYYY-MM-DD"),
        limitTime: limitTime.format("YYYY-MM-DD HH:mm"),
        now: now.format("YYYY-MM-DD HH:mm"),
        isBeforeLimit: now.isBefore(limitTime)
      });

      if (diffDays < tPlus) {
        return false; // 日期太早
      }
      if (diffDays === tPlus) {
        // 正好是目标日期，判断今天是否超过截止时间
        return now.isBefore(limitTime);
      }
      return true; // 日期超过目标日期，可以操作
    }
    return false;
  }

  // 原逻辑：使用 limitTime 判断
  const [limitHour, limitMinute] = state.limitTime.split(":").map(Number);
  const limitTime = today
    .add(limitHour, "hour")
    .add(limitMinute || 0, "minute");
  if (now.isBefore(limitTime)) {
    // 限定时间前，只能操作明天及以后
    return diffDays >= 1;
  } else {
    // 限定时间后，只能操作后天及以后
    return diffDays >= 2;
  }
};

const gettimeLimit = async () => {
  // 获取时间限制参数
  try {
    if (isCustomer.value == 1) {
      // 客户模式：获取午餐和晚餐的 T+ 时间
      // code=2 午餐，code=3 晚餐，createOrg 校区ID，value 表示 T+value
      const res = await postSyparamSelectList({ bigCode: "userPayTimeLimit" });
      if (res && Array.isArray(res.data)) {
        // 根据校区ID过滤数据（同时尝试字符串和数字匹配）
        let orgData = res.data.filter(item => item.createOrg == selectedCampusValue.value);
        // 如果没有匹配到，使用默认值
        if (orgData.length === 0) {
          state.lunchTPlus = 0;
          state.lunchBigDesc = '09:00';
          state.dinnerTPlus = 0;
          state.dinnerBigDesc = '15:00';
          state.configUpdateTime = Date.now(); // 触发响应式更新
        } else {
        const lunchItem = orgData.find(item => item.code == 2);
        const dinnerItem = orgData.find(item => item.code == 3);
        state.lunchTPlus = lunchItem ? parseInt(lunchItem.value) : 0;
        state.lunchBigDesc = lunchItem?.bigDesc ?? '09:00';
        state.dinnerTPlus = dinnerItem ? parseInt(dinnerItem.value) : 0;
        state.dinnerBigDesc = dinnerItem?.bigDesc ?? '15:00';
        state.configUpdateTime = Date.now(); // 触发响应式更新
        }
      }
    } else {
      // 原逻辑：获取普通时间限制
      const res = await postSyparamSelectList({ bigCode: "timeLimit" });
      if (res && Array.isArray(res.data)) {
        state.limitTime = res.data[0]?.bigDesc ?? "11:00";
      }
    }
  } catch (e) {
    if (isCustomer.value == 1) {
      state.lunchTPlus = 0;
      state.lunchBigDesc = '09:00';
      state.dinnerTPlus = 0;
      state.dinnerBigDesc = '15:00';
      state.configUpdateTime = Date.now(); // 触发响应式更新
    } else {
      state.limitTime = "11:00";
    }
  }
};

const prevDate = () => {
  if (selectedDateIdx.value > 0) {
    selectedDateIdx.value--;
    getStandardMealDishList();
  }
};
const nextDate = () => {
  if (selectedDateIdx.value < weekDates.value.length - 1) {
    selectedDateIdx.value++;
    getStandardMealDishList();
  }
};

const chineseMeals = ref([]);
const mealTabs = [
  //   { label: "早餐", value: 1 },
  { label: "午餐", value: 2 },
  { label: "晚餐", value: 3 },
  //   { label: "宵夜", value: 4 },
];

const getSyOrgSelectList = () => {
  const params = {}
  if(isCustomer.value == 1) {
    params.supportPayment = 1;
    params.id = route?.query?.mealOrgId;
  } else {
    params.isDelivery = 1
  }
  querySyOrgSelectList({ ...params }).then((res) => {
    campusOptions.value = res?.data ?? [];
    const filterOrg = campusOptions.value.filter(item => item.id == route?.query?.mealOrgId);
    if (filterOrg.length > 0) {
      selectedCampus.value = filterOrg[0].name;
      selectedCampusValue.value = filterOrg[0].id;
      getStandardMealDishList();
    } else {
      selectedCampus.value = campusOptions.value[0].name;
      selectedCampusValue.value = campusOptions.value[0].id;
      getStandardMealDishList();
    }
    if (isCustomer.value == 1) {
      gettimeLimit();
    }
  });
};

const getStandardMealDishList = async () => {
  try {
    const currentDate = weekDates.value[selectedDateIdx.value];
    const result = await queryStandardMealDishList({
      schedulingDate: currentDate.d,
      orgId: selectedCampusValue.value,
      mealPeriod: mealType.value,
    });

    if (result.code == "00") {
      chineseMeals.value = result.data;
    } else {
      chineseMeals.value = [];
    }
  } catch (error) {
    chineseMeals.value = [];
  }
};

function getImg(img) {
  return process.env.VUE_APP_BASE_API + "/file/" + img;
}

const handleReserve = () => {
  const currentDate = weekDates.value[selectedDateIdx.value];
  // 保存当前选中日期到localStorage
  if(isCustomer.value != 1) {
    localStorage.setItem('exclusiveRecipeSelectedDate', currentDate.d);
  } 
  if(isCustomer.value == 1) {
    router.push({
      path: "/meal/customer-ordering",
      query: {
        userId: state.userId,
        realName: state.realName,
        phone: state.phone,
        schedulingDate: currentDate.d,
        mealPeriod: mealType.value,
        mealOrgId: selectedCampusValue.value,
      },
    });
  } else {
    router.push({
      path: "/meal/reserve",
      query: {
        userId: state.userId,
        realName: state.realName,
        phone: state.phone,
        schedulingDate: currentDate.d,
        mealPeriod: mealType.value,
      },
    });
  }
};

const handleGoDetail = (item) => {
  window.wx.miniProgram.navigateTo({
    url: "/pages/food-detail/food-detail?id=" + item.id,
  });
};

onMounted(() => {
  if (route?.query?.token) {
    localStorage.setItem("token", route?.query?.token);
  }
  if (route?.query?.userId) {
    state.userId = route?.query?.userId;
  }
  if (route?.query?.realName) {
    state.realName = route?.query?.realName;
  }
  if (route?.query?.phone) {
    state.phone = route?.query?.phone;
  }

  if(route?.query?.isCustomer) {
    isCustomer.value = Number(route?.query?.isCustomer);
  }
  initWeekDates();
  gettimeLimit();
  getSyOrgSelectList();
});
</script>

<style lang="scss" scoped>
.exclusive-recipe {
  min-height: 100vh;
  background: #e9f1f8;
  padding-bottom: 100px;
  .header {
    padding: 16px 0px 0 0px;
    .custom-campus-select {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 700;
      padding-left: 12px;
      color: #013152;
      cursor: pointer;
      .campus-name {
        margin-right: 4px;
      }
      .campus-arrow {
        font-size: 18px;
      }
    }
    .van-dropdown-menu {
      margin-bottom: 8px;
    }
    .location-select {
      font-size: 18px;
      font-weight: 600;
      color: #013152;
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .date-select {
      display: flex;
      align-items: center;
      margin-top: 24px;
      position: relative;
      padding: 0 4px;
      .date-arrow {
        font-size: 22px;
        margin-top: 15px;
        color: #013152;
        cursor: pointer;
        &.disabled {
          color: #e0e0e0;
          cursor: not-allowed;
        }
        &.right {
          margin-left: 4px;
        }
        margin-right: 4px;
        z-index: 2;
      }
      .date-scroll {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow-x: auto;
        scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
          display: none;
        }
        .week-row {
          display: flex;
          margin-bottom: 4px;
          .week-label {
            flex: 0 0 44px;
            width: 44px;
            text-align: center;
            font-size: 15px;
            color: #40657D;
            font-weight: 600;
            margin-right: 8px;
          }
        }
        .date-row {
          display: flex;
          margin-top: 4px;
          .date-item {
            flex: 0 0 44px;
            width: 44px;
            height: 54px;
            background: #f5f7fa;
            border-radius: 8px;
            margin-right: 8px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .date-day {
              font-size: 18px;
              font-weight: 600;
            }
            .date-label {
              font-size: 13px;
              color: #888;
              padding-top: 6px;
            }
            &.active {
              background: #013152;
              color: #fff;
              .date-day,
              .date-label {
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
  .tab-select {
    display: flex;
    margin: 18px 0 0 0;
    padding: 0 12px;
    background: transparent;
    .tab-item {
      width: 72px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      border-radius: 18px;
      background: #e4ecf7;
      color: #013152;
      cursor: pointer;
      margin-right: 12px;
      transition: background 0.2s, color 0.2s;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        background: #013152;
        color: #fff;
      }
    }
  }
  .meal-section {
    background: #fff;
    border-radius: 12px;
    margin: 18px 12px 0 12px;
    padding: 16px 12px 12px 12px;
    .section-title {
      font-size: 17px;
      font-weight: 600;
      margin-bottom: 10px;
      text-align: left;
      display: flex;
      align-items: center;
    }
    .meal-list {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      .meal-item {
        width: 76px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .meal-img {
          width: 64px;
          height: 64px;
          border-radius: 8px;
          object-fit: cover;
        }
        .meal-name {
          margin-top: 6px;
          font-size: 15px;
          color: #333;
        }
      }
    }
    .rice {
      margin-top: 10px;
      width: 80px;
      .meal-img {
        width: 64px;
        height: 64px;
      }
      .meal-name {
        margin-top: 6px;
      }
    }
  }
  .bottom-button {
    position: fixed;
    left: 64px;
    right: 64px;
    bottom: 0;
    padding: 20px 0 32px 0;
    display: flex;
    justify-content: center;
    z-index: 10;
    .reserve-btn {
      width: calc(100vw - 128px);
      border-radius: 4px !important;
      height: 44px;
      border: 1px solid #013152;
      font-size: 16px;
      border-radius: 2px;
      font-weight: 500;
      letter-spacing: 1px;
      background: #013152;
    }
  }

  .tab-wrpa {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    height: 30px;
    align-items: center;
    margin-left: 16px;
  }
  .tab-list {
    width: 100px;
    border-radius: 26px 26px 26px 26px;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 30px;
    font-size: 13px;
  }
  .tab-name {
    color: #013152;
    width: 50px;
    text-align: center;
  }

  .active-tab {
    background-color: #013152;
    color: #fff;
    width: 50px;
    text-align: center;
    border-radius: 26px 26px 26px 26px;
    height: 100%;
    line-height: 30px;
  }

  .empty-placeholder {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 0;
    .empty-img {
      width: 60px;
      height: 60px;
      opacity: 0.6;
      margin-bottom: 8px;
    }
    .empty-text {
      color: #888;
      font-size: 15px;
    }
  }
}
</style> 